var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMTorse3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 178,
    viewBox: "0 0 143 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.737 27.1028C7.72997 45.4768 16.8709 84.7612 17.6207 98.0099C18.6464 116.133 12.3687 165.66 10.4396 177",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03025 0C9.03024 22.781 7.34565 37.6727 36.3156 37.6727",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0559 46.4487C5.01963 46.4487 1.12104 32.2471 0.514046 6.57788",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 4.28677,
    strokeLinecap: "square",
    strokeDasharray: "4.02 4.02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.509 27.1028C134.516 45.4768 125.375 84.7612 124.625 98.0099C123.6 116.133 129.877 165.66 131.806 177",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.216 0C133.216 22.781 134.9 37.6727 105.93 37.6727",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.19 46.4487C137.226 46.4487 141.125 32.2471 141.732 6.57788",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 4.28677,
    strokeLinecap: "square",
    strokeDasharray: "4.02 4.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMTorse3);
export default __webpack_public_path__ + "static/media/M-TORSE_3.d3328addf21d735bff65c722cd6587a3.svg";
export { ForwardRef as ReactComponent };